export const baseURL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3002"
    : window.location.href.split(".")[2] === "staging"
    ? "https://atci.techexpressway.staging.accenture.com/techexpresswaystage-apis"
    : "https://atci.entrylevellearning.accenture.com/techexpress-apis";

export const baseUrl = 'https://atci.lkm.accenture.com/lttmicrosite-apis';

    

